import { useEffect, useRef, useState } from 'react';
import './LogoAnimation.css';

function LogoAnimation({ isVisible }) {
  const pathRef = useRef(null);
  const fillRef = useRef(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!pathRef.current) return;

    const path = pathRef.current;
    const length = path.getTotalLength();

    // Initialize path immediately to prevent flicker
    path.style.strokeDasharray = `${length}`;
    path.style.strokeDashoffset = `${length}`;
    
    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (!isVisible || !isInitialized || !pathRef.current) return;

    const path = pathRef.current;
    
    // Small delay to ensure smooth transition
    const timer = setTimeout(() => {
      path.getBoundingClientRect(); // force reflow
      path.style.transition = 'stroke-dashoffset 1.8s ease';
      path.style.strokeDashoffset = '0';
    }, 20);

    return () => clearTimeout(timer);
  }, [isVisible, isInitialized]);

  return (
    <div 
      className="logo-animation-wrapper"
      style={{ opacity: isVisible && isInitialized ? 1 : 0, transition: 'opacity 0.3s ease' }}
    >
      <svg
        id="logo-animation"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-5 -5 191.18 91.78"
        className="logo-animation-svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <linearGradient id="logo-gradient" x1="-4.51" y1="40.89" x2="181.93" y2="40.89" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#ffcf15"/>
            <stop offset="1" stopColor="#dc037e"/>
          </linearGradient>
        </defs>
        <path
          ref={pathRef}
          d="M.02,59.84c4.22-6.1,15.37-19.52,21.8-8.86,3.65,6.55,3.75,14.6,7.51,20.74h0c-.43-.7-1.72-.9-2.37-.86,10.15-2.99,60.18-72.92,61.71-41.71-.14,14.06-6.25,30.88-1.14,43.46,3.92-3.07,7.86-8.47,10.97-12.97,14.39-18.47,27.07-45.8,47.6-57.75,21.17-7.98,23.98,10.94,19.4,26.86-4.36,18.39-13.62,47.36,15.53,46.98l.15,1.39c-35.8,8.49-32.32-29.84-28.59-53.21.24-3.47,1.05-7.71.2-10.71.23.81,1.28,1.49,2.05,1.64-13.37,4.11-32.8,35.72-44.23,47.03-6.26,6.57-23.88,28.56-29.87,11.32-1.65-12.84,2.66-25.77,2.98-38.44-.02-2.76.49-5.8-.74-8.19-.18.06.56.33.25.4-2.38,1.22-4.16,3.45-5.98,5.57-7.25,10.19-41.45,60.74-55.61,46.85-6.05-7.36-4.09-17.64-6.68-26.06.16-.01.43.2.66.16-5.19-.02-10.04,4.49-14.61,7.23l-1.01-.97.02.1Z"
          className="logo-path"
        />
        <path
          ref={fillRef}
          d="M.02,59.84c4.22-6.1,15.37-19.52,21.8-8.86,3.65,6.55,3.75,14.6,7.51,20.74h0c-.43-.7-1.72-.9-2.37-.86,10.15-2.99,60.18-72.92,61.71-41.71-.14,14.06-6.25,30.88-1.14,43.46,3.92-3.07,7.86-8.47,10.97-12.97,14.39-18.47,27.07-45.8,47.6-57.75,21.17-7.98,23.98,10.94,19.4,26.86-4.36,18.39-13.62,47.36,15.53,46.98l.15,1.39c-35.8,8.49-32.32-29.84-28.59-53.21.24-3.47,1.05-7.71.2-10.71.23.81,1.28,1.49,2.05,1.64-13.37,4.11-32.8,35.72-44.23,47.03-6.26,6.57-23.88,28.56-29.87,11.32-1.65-12.84,2.66-25.77,2.98-38.44-.02-2.76.49-5.8-.74-8.19-.18.06.56.33.25.4-2.38,1.22-4.16,3.45-5.98,5.57-7.25,10.19-41.45,60.74-55.61,46.85-6.05-7.36-4.09-17.64-6.68-26.06.16-.01.43.2.66.16-5.19-.02-10.04,4.49-14.61,7.23l-1.01-.97.02.1Z"
          className="logo-fill"
          fill="url(#logo-gradient)"
        />
      </svg>
    </div>
  );
}

export default LogoAnimation;

